import Base from '@studiometa/js-toolkit';

/**
 * @typedef {Object} FormRefs
 */

/**
 * @typedef {Object} FormInterface
 * @property {FormRefs} $refs
 */

/**
 * Homepage class.
 */
export default class Form extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Form',
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Form & FormInterface}
   */
  mounted() {
    /** @type HTMLInputElement[] */
    const fileInputs = Array.from(this.$el.querySelectorAll('input[type="file"]'));

    fileInputs.forEach((fileInput) => {
      const container = this.findAncestor(fileInput, 'gfield');
      const label = container.querySelector('.gfield_label');

      const initialInnerHTML = label.innerHTML;

      fileInput.onchange = () => {
        const selectedFile = fileInput.files[0];

        if (selectedFile) {
          label.innerHTML = selectedFile.name;
        } else {
          label.innerHTML = initialInnerHTML;
        }
      };
    });
  }

  /**
   * Find ancestor with className.
   *
   * @this {Form & FormInterface}
   *
   * @param {HTMLElement} el
   * @param {String} className
   *
   * @return {HTMLElement}
   */
  findAncestor(el, className) {
    let searchEl = el;

    while (searchEl && !searchEl.classList.contains(className)) {
      searchEl = searchEl.parentElement;
    }

    return searchEl;
  }
}
